module.exports = __webpack_public_path__ + "img/bg2.237f223f.jpg";